import { BaseControl } from "../base-control";

class MultiCheckBoxControlCtrl extends BaseControl {
  isActiveOption = false;
  requireValid = false;
  constructor(BaseControlService, $scope) { 
    'ngInject';
    super(BaseControlService, $scope);
  }

  async initializeControlData() {
    await super.initializeControlData();
    this.updateFlags();
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    this.updateFlags();
  }

  updateFlags() {
    this.requiredValid =  !this.required || this.model?.value;
    this.isActiveOption = this.getModelArray().includes(this.token.options.choice.value);
  }

  flipBoolModel(optn) {
    const arr = this.getModelArray();
    arr.includes(optn)
      ? this.stdModel(arr.filter(e => e !== optn).sort())
      : this.stdModel([...arr, optn].sort());
  }

  checkboxKeyDown(keyEvent, optn) {
    if ([13, 32].includes(keyEvent.which)) { // enter, spacebar
      keyEvent.preventDefault();
      this.flipBoolModel(optn);
    }
  }

  getModelArray() {
    return this.model.value ? this.model.value.split(this.token.control.delimiter) : [];
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/multicheckbox-control/multicheckbox-control.component.html",
  controller: MultiCheckBoxControlCtrl
};